/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrialsControllerUpdateMutationRequest, TrialsControllerUpdateMutationResponse, TrialsControllerUpdatePathParams, TrialsControllerUpdate400, TrialsControllerUpdate401, TrialsControllerUpdate403, TrialsControllerUpdate404, TrialsControllerUpdate422 } from "../../models/trialsController/TrialsControllerUpdate";

function getTrialsControllerUpdateUrl(id: TrialsControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/trials/${id}` as const }  
  return res
}

/**
 * @description PATCH body must include exactly one transition: expiresAt | status=CANCELED | status=CONVERTED | status=ACTIVE.
 * @summary Update a trial — extend, cancel, convert, or uncancel
 * {@link /api/v1/trials/:id}
 */
export async function trialsControllerUpdate(id: TrialsControllerUpdatePathParams["id"], data?: TrialsControllerUpdateMutationRequest, config: Partial<RequestConfig<TrialsControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<TrialsControllerUpdateMutationResponse, ResponseErrorConfig<TrialsControllerUpdate400 | TrialsControllerUpdate401 | TrialsControllerUpdate403 | TrialsControllerUpdate404 | TrialsControllerUpdate422>, TrialsControllerUpdateMutationRequest>({ method : "PATCH", url : getTrialsControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}